@if(!isLoading) {
  <ng-container *transloco="let t; prefix: 'assetOverview.assetInformation'">
  <!-- TOP ROW -->
  <div class="row gx-4 mb-3 top-row">
    <div class="col-3">
      <div class="asset-card asset-photo-card" [class.asset-photo-card--upload]="showImageUpload">
        <input type="file" #imageInput [accept]="acceptedImageTypes" hidden (change)="onImageSelected($event)" />

        @if (isLoadingAssetImage) {
          <div class="asset-photo-loader">
            <div class="spinner-border" role="status">
              <span class="visually-hidden">{{ t('loadingImage') }}</span>
            </div>
          </div>
        } @else if (assetImageUrl) {
          <div class="asset-photo-wrapper">
            <img
              [src]="assetImageUrl"
              [alt]="t('assetPhotoAlt')"
              class="asset-photo"
              [class.asset-photo--loaded]="isImageLoaded"
              (load)="onImageLoad()"
              (error)="onImageError()" />
            @if (isUploadingImage || !isImageLoaded) {
              <div class="asset-photo-overlay">
                <div class="spinner-border" role="status">
                  <span class="visually-hidden">{{ isUploadingImage ? t('uploadingImage') : t('loadingImage') }}</span>
                </div>
              </div>
            } @else {
              <button class="icon-button asset-photo-edit" type="button" [attr.aria-label]="t('changeImage')" (click)="imageInput.click()">
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M2.33343 12.2487C2.38068 12.2487 2.42793 12.2429 2.4746 12.2312L4.80793 11.6479C4.9106 11.6222 5.00452 11.5691 5.07918 11.4945L12.2501 4.32355C12.4706 4.10305 12.5919 3.81022 12.5919 3.49872C12.5919 3.18722 12.4706 2.89439 12.2501 2.67389L11.3249 1.74872C10.8839 1.30772 10.1163 1.30772 9.67527 1.74872L2.50435 8.91964C2.42968 8.9943 2.3766 9.08822 2.35093 9.1903L1.7676 11.5236C1.71743 11.7226 1.77635 11.9326 1.92102 12.0778C2.03127 12.1886 2.1806 12.2487 2.33343 12.2487ZM10.5001 2.57355L11.4253 3.49872L10.5001 4.42389L9.57493 3.49872L10.5001 2.57355ZM3.44352 9.63014L8.7501 4.32355L9.67527 5.24872L4.3681 10.5553L3.13493 10.8633L3.44352 9.63014Z" fill="#9FA1A4"/>
                </svg>
              </button>
            }
          </div>
        } @else {
          <div
            class="image-upload-area"
            [class.drag-over]="isImageDragOver"
            (click)="imageInput.click()"
            (dragover)="onImageDragOver($event)"
            (dragleave)="onImageDragLeave($event)"
            (drop)="onImageDrop($event)">
            <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path opacity="0.2" d="M40.5 9V39H7.5V9C7.5 8.20435 7.81607 7.44129 8.37868 6.87868C8.94129 6.31607 9.70435 6 10.5 6H37.5C38.2956 6 39.0587 6.31607 39.6213 6.87868C40.1839 7.44129 40.5 8.20435 40.5 9Z" fill="#9FA1A4"/>
              <path d="M42 27V39C42 39.3978 41.842 39.7793 41.5607 40.0606C41.2794 40.3419 40.8978 40.5 40.5 40.5H7.5C7.10218 40.5 6.72064 40.3419 6.43934 40.0606C6.15804 39.7793 6 39.3978 6 39V27C6 26.6021 6.15804 26.2206 6.43934 25.9393C6.72064 25.658 7.10218 25.5 7.5 25.5C7.89782 25.5 8.27936 25.658 8.56066 25.9393C8.84196 26.2206 9 26.6021 9 27V37.5H39V27C39 26.6021 39.158 26.2206 39.4393 25.9393C39.7206 25.658 40.1022 25.5 40.5 25.5C40.8978 25.5 41.2794 25.658 41.5607 25.9393C41.842 26.2206 42 26.6021 42 27ZM17.5613 14.5612L22.5 9.62058V27C22.5 27.3978 22.658 27.7793 22.9393 28.0606C23.2206 28.3419 23.6022 28.5 24 28.5C24.3978 28.5 24.7794 28.3419 25.0607 28.0606C25.342 27.7793 25.5 27.3978 25.5 27V9.62058L30.4387 14.5612C30.7202 14.8427 31.102 15.0008 31.5 15.0008C31.898 15.0008 32.2798 14.8427 32.5613 14.5612C32.8427 14.2797 33.0008 13.898 33.0008 13.5C33.0008 13.1019 32.8427 12.7202 32.5613 12.4387L25.0613 4.93871C24.9219 4.79924 24.7565 4.68861 24.5744 4.61312C24.3923 4.53763 24.1971 4.49878 24 4.49878C23.8029 4.49878 23.6077 4.53763 23.4256 4.61312C23.2435 4.68861 23.0781 4.79924 22.9387 4.93871L15.4387 12.4387C15.1573 12.7202 14.9992 13.1019 14.9992 13.5C14.9992 13.898 15.1573 14.2797 15.4387 14.5612C15.7202 14.8427 16.102 15.0008 16.5 15.0008C16.898 15.0008 17.2798 14.8427 17.5613 14.5612Z" fill="#9FA1A4"/>
            </svg>
            <span class="image-upload-title">{{ t('uploadPrompt') }}</span>
            <span class="image-upload-subtitle">{{ t('uploadHint', { size: maxImageSizeMb }) }}</span>
          </div>
        }
      </div>
    </div>

    <div class="col-9">
      <div class="asset-card asset-overview-card">
        <div class="asset-overview-details">
          <div class="card-header">
            <span class="card-header-title">{{ overviewTitle }}</span>
            <button class="icon-button" type="button" [attr.aria-label]="t('editLifecyclePoints')" (click)="openEditLifecyclePoints()">
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2.33343 12.2487C2.38068 12.2487 2.42793 12.2429 2.4746 12.2312L4.80793 11.6479C4.9106 11.6222 5.00452 11.5691 5.07918 11.4945L12.2501 4.32355C12.4706 4.10305 12.5919 3.81022 12.5919 3.49872C12.5919 3.18722 12.4706 2.89439 12.2501 2.67389L11.3249 1.74872C10.8839 1.30772 10.1163 1.30772 9.67527 1.74872L2.50435 8.91964C2.42968 8.9943 2.3766 9.08822 2.35093 9.1903L1.7676 11.5236C1.71743 11.7226 1.77635 11.9326 1.92102 12.0778C2.03127 12.1886 2.1806 12.2487 2.33343 12.2487ZM10.5001 2.57355L11.4253 3.49872L10.5001 4.42389L9.57493 3.49872L10.5001 2.57355ZM3.44352 9.63014L8.7501 4.32355L9.67527 5.24872L4.3681 10.5553L3.13493 10.8633L3.44352 9.63014Z" fill="#9FA1A4"/>
              </svg>
            </button>
          </div>

          @if (isRefreshingOverview) {
            <div class="overview-loader">
              <div class="spinner-border" role="status">
                <span class="visually-hidden">{{ t('loadingOverview') }}</span>
              </div>
            </div>
          } @else {
            <div class="overview-body">
              <section class="overview-section">
                <div class="section-title">{{ t('registrationDetails') }}</div>

                <div class="details-grid cols-3">
                  <div class="details-item">
                    <div class="details-label">{{ t('assetName') }}</div>
                    <div class="details-value">{{ registration.assetName || assetName }}</div>
                  </div>

                  <div class="details-item">
                    <div class="details-label">{{ t('plateNumber') }}</div>
                    <div class="details-value">{{ registration.plateNumber || ('common.unknown' | transloco) }}</div>
                  </div>

                  <div class="details-item">
                    <div class="details-label">{{ t('mainColour') }}</div>
                    <div class="details-value">
                      @if (registration.mainColour) {
                        @if (registration.mainColourHex) {
                          <span class="colour-swatch" [style.background]="registration.mainColourHex"></span>
                        }
                        <span>{{ registration.mainColour }}</span>
                      } @else {
                        <span>{{ t('none') }}</span>
                      }
                    </div>
                  </div>
                </div>
              </section>

              <div class="section-divider"></div>

              <section class="overview-section overview-section--fuel">
                <div class="section-title">{{ t('fuelLifecycleData') }}</div>

                @if (fuel && fuel.tanks.length > 0) {
                  <div class="details-grid cols-2">
                    <div class="details-item">
                      <div class="details-label">{{ t('fuelProbes') }}</div>
                      <div class="details-value"> {{ fuel.probes }} </div>
                    </div>

                    <div class="details-item">
                      <div class="details-label">{{ t('totalFuelCapacity') }}</div>
                      <div class="details-value"> {{ fuel.totalCapacityLitres.toLocaleString() }} ℓ</div>
                    </div>
                  </div>

                  <div class="details-grid" [ngClass]="{
                    'cols-2': fuel.tanks.length === 2,
                    'cols-4': fuel.tanks.length > 2 && fuel.tanks.length < 5,
                    'cols-5': fuel.tanks.length === 5
                  }">
                    @for(tank of fuel.tanks; track tank.tankNumber) {
                      <div class="details-item">
                        <div class="details-label">{{ t('tank', { number: tank.tankNumber }) }}</div>
                        <div class="details-value">
                          @if (tank.capacityLitres != null) {
                            {{ tank.capacityLitres.toLocaleString() }} ℓ
                          } @else {
                            -
                          }
                        </div>
                      </div>
                    }
                  </div>
                } @else {
                  <div class="fuel-empty-state">{{ t('noFuelCalibration') }}</div>
                }

                <div class="lifecycle-section">
                  <div class="lifecycle-bar-wrapper">
                    <div class="lifecycle-bar">
                      <div class="lifecycle-bar-fill" [style.width.%]="lifecycleFillPercent"></div>
                      @if (lifecycle?.sellingPointKm != null) {
                        <div class="lifecycle-selling-line" [style.left.%]="sellingPointPercent"></div>
                      }
                      <span
                        class="lifecycle-bar-value"
                        [class.lifecycle-bar-value--centred]="isLifecycleValueCentred"
                        [style.left.%]="lifecycleValuePercent">{{ t('kmTravelled', { km: (lifecycle?.odometerKm ?? 0).toLocaleString() }) }}</span>
                    </div>

                    @if (lifecycle?.sellingPointKm != null) {
                      <div class="lifecycle-selling-marker" [style.left.%]="sellingPointPercent">
                        <div class="lifecycle-selling-pointer"></div>
                      </div>
                    }
                  </div>

                  <div class="lifecycle-bar-legend">
                    <span class="legend-label legend-left">{{ t('lifecycle.new') }}</span>
                    <span class="legend-label legend-right">{{ t('lifecycle.retire') }}</span>
                    @if(showSellingLabel) {
                      <span class="legend-label legend-selling" [style.left.%]="sellingPointPercent">{{ t('lifecycle.sellingPoint') }}</span>
                    }
                  </div>
                </div>
              </section>
            </div>
          }
        </div>
      </div>
    </div>
  </div>

  <!-- BOTTOM ROW -->
  @if (isLoadingVehicleDetails) {
  <div class="row gx-4 bottom-row">
    <div class="col-12">
      <div class="vehicle-details-loader">
        <div class="spinner-border" role="status">
          <span class="visually-hidden">{{ t('loadingVehicleDetails') }}</span>
        </div>
      </div>
    </div>
  </div>
  } @else if (hasVehicleDetails) {
  @if (hasPartialVehicleDetails && !isPartialNoticeDismissed) {
  <div class="row gx-4 mb-3">
    <div class="col-12">
      <div class="vin-banner" role="status">
        <svg class="vin-banner__icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <path d="M12 2C6.486 2 2 6.486 2 12C2 17.514 6.486 22 12 22C17.514 22 22 17.514 22 12C22 6.486 17.514 2 12 2ZM13 17H11V11H13V17ZM13 9H11V7H13V9Z" fill="#3873C9"/>
        </svg>

        <div class="vin-banner__content">
          <div class="vin-banner__title">{{ t('partialNotice.title') }}</div>
          <div class="vin-banner__text">{{ t('partialNotice.text') }}</div>
        </div>

        <button class="btn-close vin-banner__close" type="button" [attr.aria-label]="t('partialNotice.dismiss')" (click)="dismissPartialNotice()"></button>
      </div>
    </div>
  </div>
  }

  <div class="row gx-4 bottom-row">
    <div class="col-4">
      <div class="asset-card vehicle-spec-card">
        <div class="vehicle-spec-details">
          <div class="card-header">
            <span class="card-header-title">{{ t('vehicleSpecifications.title') }}</span>
          </div>

          <div class="details-body">
            <div class="details-item">
              <div class="details-label">{{ t('vehicleSpecifications.vin') }}</div>
              <div class="details-value">{{ vehicleSpecifications.vin || '-' }}</div>
            </div>

            <div class="details-item">
              <div class="details-label">{{ t('vehicleSpecifications.productionSequence') }}</div>
              <div class="details-value">{{ vehicleSpecifications.productionSequence || '-' }}</div>
            </div>

            <div class="details-item">
              <div class="details-label">{{ t('vehicleSpecifications.dateOfManufacture') }}</div>
              <div class="details-value">{{ (vehicleSpecifications.dateOfManufacture | date: 'dd MMM yyyy') || '-' }}</div>
            </div>

            <div class="details-item">
              <div class="details-label">{{ t('vehicleSpecifications.modelYear') }}</div>
              <div class="details-value">{{ vehicleSpecifications.modelYear || '-' }}</div>
            </div>

            <div class="details-item">
              <div class="details-label">{{ t('vehicleSpecifications.countryOfManufacture') }}</div>
              <div class="details-value">{{ vehicleSpecifications.countryOfManufacture || '-' }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-4">
      <div class="asset-card basic-vehicle-card">
        <div class="basic-vehicle-details">
          <div class="card-header">
            <span class="card-header-title">{{ t('basicVehicleDetails.title') }}</span>
          </div>

          <div class="details-body">
            <div class="details-item">
              <div class="details-label">{{ t('basicVehicleDetails.make') }}</div>
              <div class="details-value">{{ basicVehicleDetails.make || '-' }}</div>
            </div>

            <div class="details-item">
              <div class="details-label">{{ t('basicVehicleDetails.model') }}</div>
              <div class="details-value">{{ basicVehicleDetails.model || '-' }}</div>
            </div>

            <div class="details-item">
              <div class="details-label">{{ t('basicVehicleDetails.bodyType') }}</div>
              <div class="details-value">{{ basicVehicleDetails.bodyType || '-' }}</div>
            </div>

            <div class="details-item">
              <div class="details-label">{{ t('basicVehicleDetails.cabType') }}</div>
              <div class="details-value">{{ basicVehicleDetails.cabType || '-' }}</div>
            </div>

            <div class="details-item">
              <div class="details-label">{{ t('basicVehicleDetails.chassisFrame') }}</div>
              <div class="details-value">{{ basicVehicleDetails.chassisFrame || '-' }}</div>
            </div>

            <div class="details-item">
              <div class="details-label">{{ t('basicVehicleDetails.axleConfiguration') }}</div>
              <div class="details-value">{{ basicVehicleDetails.axleConfiguration || '-' }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-4">
      <div class="asset-card mech-perf-card">
        <div class="mech-perf-details">
          <div class="card-header">
            <span class="card-header-title">{{ t('mechanicalPerformance.title') }}</span>
          </div>

          <div class="details-body">
            <div class="details-item">
              <div class="details-label">{{ t('mechanicalPerformance.engine') }}</div>
              <div class="details-value">{{ mechanicalPerformanceData.engine || '-' }}</div>
            </div>

            <div class="details-item">
              <div class="details-label">{{ t('mechanicalPerformance.power') }}</div>
              <div class="details-value">{{ mechanicalPerformanceData.power || '-' }}</div>
            </div>

            <div class="details-item">
              <div class="details-label">{{ t('mechanicalPerformance.transmission') }}</div>
              <div class="details-value">{{ mechanicalPerformanceData.transmission || '-' }}</div>
            </div>

            <div class="details-item">
              <div class="details-label">{{ t('mechanicalPerformance.grossVehicleWeight') }}</div>
              <div class="details-value">{{ mechanicalPerformanceData.grossVehicleWeight || '-' }}</div>
            </div>

            <div class="details-item">
              <div class="details-label">{{ t('mechanicalPerformance.fuelType') }}</div>
              <div class="details-value">{{ mechanicalPerformanceData.fuelType || '-' }}</div>
            </div>

            <div class="details-item">
              <div class="details-label">{{ t('mechanicalPerformance.co2Output') }}</div>
              <div class="details-value">{{ mechanicalPerformanceData.co2Output || '-' }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  } @else {
  <div class="row gx-4 bottom-row">
    <div class="col-12">
      <div class="vin-banner">
        <svg class="vin-banner__icon" width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <path d="M0 22C0 9.84974 9.84974 0 22 0C34.1503 0 44 9.84974 44 22C44 34.1503 34.1503 44 22 44C9.84974 44 0 34.1503 0 22Z" fill="#3873C9"/>
          <path d="M22 12C16.486 12 12 16.486 12 22C12 27.514 16.486 32 22 32C27.514 32 32 27.514 32 22C32 16.486 27.514 12 22 12ZM23 27H21V21H23V27ZM23 19H21V17H23V19Z" fill="white"/>
        </svg>

        <div class="vin-banner__content">
          @if (hasVehicleDetailsError) {
            <div class="vin-banner__title">{{ t('vehicleError.title') }}</div>
            <div class="vin-banner__text">{{ t('vehicleError.text') }}</div>
            <button class="vin-banner__retry" type="button" (click)="getVehicleInformation()">{{ t('vehicleError.retry') }}</button>
          } @else {
            <div class="vin-banner__title">{{ t('vinUnavailable.title') }}</div>
            <div class="vin-banner__text">{{ t('vinUnavailable.text') }}</div>
          }
        </div>
      </div>
    </div>
  </div>
  }
  </ng-container>
} @else {
  <div class="spinner-container d-flex align-items-center justify-content-center spinner-border"></div>
}